package dev.terrakok.mapitan.domain

import androidx.compose.ui.platform.ClipEntry

actual fun String.asClipEntry(): ClipEntry = ClipEntry.withPlainText(this)
